import { CellContext, createColumnHelper } from '@tanstack/react-table';
import { Users, Layers } from 'lucide-react';

import { useAdditionalFunctionalitySettings } from '@/react/portainer/settings/queries/useAdditionalFunctionalitySettings';

import { buildNameColumn } from '@@/datatables/buildNameColumn';
import { Button } from '@@/buttons';
import { Link } from '@@/Link';
import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { EnvironmentGroup } from '../../types';

const columnHelper = createColumnHelper<EnvironmentGroup>();

export const columns = [
  buildNameColumn<EnvironmentGroup>('Name', '.group', 'environment-group-name'),
  columnHelper.display({
    header: 'Actions',
    cell: ActionsCell,
  }),
];

function ActionsCell({
  row: { original: item },
}: CellContext<EnvironmentGroup, unknown>) {
  const settingsQuery = useAdditionalFunctionalitySettings();

  if (!settingsQuery.data) {
    return null;
  }

  const isPoliciesEnabled = settingsQuery.data.additionalFunctionality.Policies;

  const managePoliciesButton = (
    <Button
      as={isPoliciesEnabled ? Link : 'button'}
      props={
        isPoliciesEnabled
          ? {
              to: 'portainer.policies',
              params: { id: item.Id },
            }
          : undefined
      }
      color="link"
      className="!pl-0"
      icon={Layers}
      disabled={!isPoliciesEnabled}
      data-cy={`manage-policies-button_${item.Name}`}
    >
      Manage policies
    </Button>
  );

  return (
    <div className="flex gap-x-2">
      {!isPoliciesEnabled ? (
        <TooltipWithChildren message="You must enable Policy Based Management feature under Addtional Functionality first">
          <div className="inline-block">{managePoliciesButton}</div>
        </TooltipWithChildren>
      ) : (
        managePoliciesButton
      )}
      <Button
        as={Link}
        props={{
          to: '.group.access',
          params: { id: item.Id },
        }}
        color="link"
        icon={Users}
        data-cy={`manage-access-button_${item.Name}`}
      >
        Manage access
      </Button>
    </div>
  );
}
